import * as React from "react";
import {ModalCGU} from "../../../../modals/modal-cgu";
import {Context} from "../../../../../../store";
import {AsyncButtonWithSpinner} from "../../../../../shared/async-button-with-spinner";
import AsyncStorage from '@react-native-async-storage/async-storage'

export function PaymentButton({children, onPay, product, ...buttonProps}) {

    const {
        store: { isCGUApproved },
        actions: { CGUApproved }
    } = React.useContext(Context)

    const [isShowCGU, setShowCGU] = React.useState(false)
    const showCGU = () => setShowCGU(true)
    const hideCGU = () => setShowCGU(false)
    const approveCGU = () => {
        CGUApproved()
        hideCGU()

        AsyncStorage.setItem('@cguApproved', "true")
    }

    return <>
        <AsyncButtonWithSpinner {...buttonProps} onPress={async () => {
            if(isCGUApproved) await onPay()
            else showCGU()
        }}>{children}</AsyncButtonWithSpinner>

        <ModalCGU product={product} visible={isShowCGU} close={hideCGU} approve={approveCGU} onPay={onPay} />
    </>
}